import { Social } from "../common/social-contact/social-contact";
import "./about.css";
import Typewriter from "typewriter-effect";
// const typii = (type)=>{
//     type.typeString("Web Developer").pauseFor(2000).deleteAll().typeString(" Mern Stack Developer").pauseFor(2000).deleteAll().typeString("Full Stack Developer").pauseFor(2000).deleteAll().start()
        
// }
// const typii2 = (type)=>{
//     type.typeString("Web Developer").pauseFor(2000).deleteAll().typeString(" Mern Stack Developer").pauseFor(2000).deleteAll().typeString("Full Stack Developer").callFunction().start()
        
// }
export function About(){
    return(<div className="about">
        <div className="about-top">
            <div className="about-info">
                Hello There,👋 I am<br/><span className="info-name"> Aditya Pathak</span><br/>
              <p className="typing">I am a &nbsp;</p><span className="typing"><Typewriter options={{
    strings: ['Web Developer', ' Mern Stack Developer',"Full Stack Developer"],
    autoStart: true,
    loop: true,
  }}className="typing"/></span>
  <p className="about-desc">Dedicated Full Stack Developer specializing in the MERN stack, bringing a blend of technical expertise, collaborative spirit, and keen attention to detail. Proven track record of crafting impactful products, with a continuous commitment to staying abreast of the latest technologies and a strong inclination towards continuous learning for skill enhancement. Eager to contribute dynamic development skills to create innovative solutions.</p>
            </div>
            <div className="about-photo">
                <img src={require("../assets/pic 31.png")} alt="" className="pic1" />
            </div>
        </div>
        <div className="download">
            <a href="https://drive.google.com/uc?export=download&id=1rrx3CirI85OTJjyyreZigymbhhcmY8TN" target="_blank" >Resume
            <i className="fi-rr-cloud-download download-icon"></i>
            
            </a>
            
            
        </div>
       <a href="https://api.whatsapp.com/send/?phone=+918602116351&text&app_absent=0" target="_blank"><div className="download phone"><i class="fi fi-rr-phone-call"></i>&nbsp;+91 8602116351 </div></a> 
       <a href="mailto:manhit06@gmail.com" target="_blank"><div className="download email"><i class="fi fi-rr-envelope"></i>&nbsp;manhit06@gmail.com </div></a> 
        
    </div>)

    
}